import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BranchModel } from '@shared/models/branch.model';
import { RestaurantModel } from '@shared/models/restaurant.model';

export type MobileMenuItemInputs = {
  label: string;
  icon: string;
  route: string;
  permission: boolean;
  clickCallback?: () => void;
};

@Component({
    selector: 'app-mobile-menu-item',
    templateUrl: './mobile-menu-item.component.html',
    styleUrls: ['./mobile-menu-item.component.scss'],
    standalone: false
})
export class MobileMenuItemComponent implements OnInit {
  @Input() label: string;
  @Input() icon: string;
  @Input() route: string;
  @Input() clickCallback: () => void = () => {};
  restaurant: RestaurantModel;
  branch: BranchModel;
  currentLAnguage:string ='';
  
  get isArabic() {
    return this.translate.currentLang === 'ar';
  }

  get showLabel() {
    return (
      this.label !== 'Dashboard' &&
      this.label !== 'Restaurants' &&
      this.label !== 'Logout' &&
      this.label !== 'Profile' &&
      this.restaurant &&
      this.branch
    );
  }
  
  get mainLabel() {
    return (
      this.label === 'Dashboard' || this.label === 'Restaurants' || this.label === 'Profile' || this.label === 'Logout'
    );
  }

  get isCurrentRoute(): boolean {
    if (!this.route) return false;
    return this.router.url.startsWith(this.route);
  }

  constructor(public translate: TranslateService, private router: Router) {
    this.currentLAnguage = this.translate.currentLang;
  }

  ngOnInit() {
    this.restaurant = JSON.parse(localStorage.getItem('restaurant'));
    this.branch = JSON.parse(localStorage.getItem('branch'));
  }

  onClick() {
    if (this.clickCallback) {
      this.clickCallback();
    }
  }
}
